import React, { useState, useEffect } from 'react';
import config from '../../config'
import axios from 'axios'

const FindOrder = ({ handleSetOrder, handleSetOrderer }) => {
  /* Check if we have a customer and an order ID */
  var queryParams = (new URL(document.location)).searchParams;
  var orderId = queryParams.get("orderId");
  var customerEmail = queryParams.get("customer");

  const [ error, setError ] = useState( false );
  const [ loading, setLoading ] = useState( false );
  const [ form, setForm ] = useState({
    email: customerEmail || '',
    orderNumber: orderId || '',
  });

  const handleFormSubmit = async e => {
    setError( false );
    setLoading( true );

    e && e.preventDefault();
    e && e.stopPropagation();

    /* Get the form values */
    const { email, orderNumber } = form;

    /** First, get all of the items attached to the order from shopify
     *  Then, make a call to the sync db to check if that order number
     *  already has returns details stored against it.
     */
    const { data: order } = await axios.get( `${config.backendUrl}/shopify-store/${config.storeId}/order?email=${encodeURIComponent(email)}&orderNumber=${orderNumber}` );
    const { data: prevReturn } = await axios.get(`${config.backendUrl}/shopify-store/${config.storeId}/returns/${orderNumber}`);
    const prevReturnedItems = prevReturn && prevReturn !== '' ? prevReturn.items : null;

    /** If data exists in the sync database,
     *  then loop through the items from shopify API and add
     *  a property that says that item has already been exchanged/returned
     */
    if (prevReturnedItems) {
      prevReturnedItems.forEach(item => {
        order.line_items.forEach(oitem => {
          if (oitem.id === item.id) {
            oitem.hasBeenReturned = true;
            oitem.returnReason = item.type;
          }
        })
      });
    }

    setLoading( false );
    
    if ( !order.id ) {
      setError( 'Could not find order' );
      return;
    }

    handleSetOrderer({
      orderNumber,
      email
    })

    handleSetOrder( order );

    return false;
  };

  /* eslint-disable */
  useEffect(() => {
    if ( customerEmail && orderId ) {
      handleFormSubmit();
    }
  }, []);

  const handleChange = field => event => {
    setForm({ ...form, [field]: event.target.value });
  }

  return (
    <div>
      <h1>Guest Returns Portal</h1>

      <form method="post" action="#" onSubmit={handleFormSubmit}>
        { error && (
          <div className="error">{error}</div>
        )}

        { loading && (
          <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
        ) }

        { !loading && (
          <div>
            <input 
              className="returns-text" 
              name="email" 
              type="email" 
              required
              placeholder="Email"
              value={form.email}
              onChange={handleChange( 'email' )}
            />

            <input 
              className="returns-text" 
              name="orderNumber" 
              type="text" 
              required
              placeholder="Order Number"
              value={form.orderNumber}
              onChange={handleChange( 'orderNumber' )}
            />

            <input 
              type="submit" 
              className="tb-btn" 
              value="Next"
            />
          </div>
        )}
      </form>
    </div>
  );
}

export default FindOrder;